<template>
  <div class="no-content py-5">
    {{msg}}
  </div>
</template>

<script>
export default {
  name: 'NoContent',
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
.no-content {
  background-color: #F5F5F5;
  border-radius: 7px;
  color: #a0a0a0;
  font-size: 15px;
  text-align: center;
  @include media-breakpoint-down(lg) {
    font-size: 12px;
  }
}
</style>
